<template>
  <div class="wrapper">
    <Sidebar />
    <div class="d-flex flex-column page-content bg-light">
      <Navbar />
      <div class="flex-grow-1 py-4">
        <router-view />
      </div>
      <footer-component />
      <SessionExpiredAlert />
      <UserDesactivated />
      <notifications position="top center">
        <template
          slot="body"
          slot-scope="{ item, close }"
        >
          <v-alert
            class="mt-4"
            dense
            prominent
            :type="item.type"
            dismissible
            @click="close"
          >
            {{ item.text }}
          </v-alert>
        </template>
      </notifications>
    </div>
  </div>
</template>
<script>

import Sidebar from '@/common/components/Sidebar'
import FooterComponent from '@/common/components/Footer.vue'
import {mapGetters} from 'vuex'
import Navbar from "@/student/components/Navbar.vue";
import SessionExpiredAlert from "@/common/components/SessionExpiredAlert.vue";
import UserDesactivated from "@/common/components/UserDesactivated.vue";

export default {
  components: {
    Sidebar,
    FooterComponent,
    Navbar,
    SessionExpiredAlert,
    UserDesactivated,
  },
  computed: {
    ...mapGetters(['authUser']),
  },
}
</script>
